import React from 'react';
import styles from './ListingLoader.module.scss';

const ListingLoader = ({ loaderWidth = '100px', loaderHeight = '100px', color = 'var(--ant-color-primary)' }) => {
  return (
    <div
      style={{ '--loader-width': loaderWidth, '--loader-height': loaderHeight, '--spinner-color': color }}
      className={styles.loaderContainer}
    ></div>
  );
};

export default ListingLoader;
